export const validateUrl = (data: string, domain?: string) => {
    let domainCheck = true;
    domain && (domainCheck = data.indexOf(domain) > -1);
    return data.match(/(^http[s]?:\/{2})|(^www)|(^\/{1,2})/) && domainCheck;
};
